<template>
  <div
    class="sections"
    :class="[`text-color-${templateSettings.design['text-color']}`]"
  >
    <div
      v-for="section in sections"
      :key="section.id"
      class="section-wrapper"
      :id="section.element_id ? section.element_id : `section-${section.id}`"
      :class="sectionClasses(section)"
    >
      <component
        :is="section.type"
        :section="section"
        :templateSettings="templateSettings"
        :builder="false"
      >
        <template v-slot:toolbar>
          <section-editor-toolbar
            v-if="showEditorToolbar"
            :section="section"
            :pageID="pageID"
          ></section-editor-toolbar>
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import SectionComponents from './types'
import SectionEditorToolbar from './SectionEditorToolbar'
import { mapState } from 'vuex'

export default {
  name: 'BaseSection',
  props: {
    pageID: {
      type: String,
      required: true
    },
    sections: {
      type: Array,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    }
  },
  components: {
    ...SectionComponents,
    SectionEditorToolbar
  },
  computed: {
    ...mapState('editor', ['drawer']),
    showEditorToolbar() {
      return this.isLoggedIn && this.currentUser.mode == 'editor'
    }
  },
  methods: {
    sectionClasses(section) {
      let classes = section.element_classes || ''

      if (section.id == this.drawer.itemID) {
        classes += ' selected-section'
      }

      if (
        section.design['background-color'] == 'var(--primary-color)' ||
        (section.layout['content-box'] == '1' &&
          section.layout['content-box-color'] == 'var(--primary-color)')
      ) {
        classes += ` text-color-${this.templateSettings.design['primary-text-color']}`
      }

      if (
        section.design['background-color'] == 'var(--secondary-color)' ||
        (section.layout['content-box'] == '1' &&
          section.layout['content-box-color'] == 'var(--secondary-color)')
      ) {
        classes += ` text-color-${this.templateSettings.design['secondary-text-color']}`
      }

      return classes
    }
  }
}
</script>

<style>
.section-wrapper {
  position: relative;
  transition: box-shadow 0.3s ease 0s;
}
.selected-section {
  box-shadow: 0 0 5px 2px #45a3d6;
  z-index: 10;
}
</style>
